import React from "react";
import "../../styles/common.css";
import "./styling/EditContentModal.css";
import { EditContentModalProps } from "../types";
import { useBodyScrollLock } from "../hooks/useBodyScrollLock";
import { EditContentForm } from "./EditContentModal/EditContentForm";
import { useEditContentModalState } from "./EditContentModal/useEditContentModalState";
import { EditContentLoadingState } from "./EditContentModal/EditContentLoadingState";
import { EditContentErrorState } from "./EditContentModal/EditContentErrorState";

export const EditContentModal: React.FC<EditContentModalProps> = (props) => {
    const { onClose, showSuccessIndicator } = props;
    useBodyScrollLock();

    const {
        isLoading,
        fetchErrorMessage,
        fetchErrorDetails,
        isFallbackEditing,
        formState,
        handleSubmit,
        isSaving,
        handleRetry,
        handleUseCachedData,
    } = useEditContentModalState(props);

    if (isLoading) {
        return <EditContentLoadingState onClose={onClose} />;
    }

    if (fetchErrorMessage) {
        return (
            <EditContentErrorState
                onClose={onClose}
                onRetry={handleRetry}
                onUseCachedData={handleUseCachedData}
                fetchErrorMessage={fetchErrorMessage}
                fetchErrorDetails={fetchErrorDetails}
            />
        );
    }

    return (
        <div className="modal-overlay edit-modal-overlay" onClick={onClose}>
            <div
                className="modal-content edit-modal-content"
                onClick={(event) => event.stopPropagation()}
            >
                <button onClick={onClose} className="close-button" aria-label="Close edit modal">
                    &times;
                </button>
                <div className="modal-header">
                    <h2>Edit Content</h2>
                </div>
                <div className="modal-body">
                    <EditContentForm
                        state={formState}
                        onSubmit={handleSubmit}
                        isSaving={isSaving}
                        showSuccessIndicator={showSuccessIndicator}
                        isFallbackEditing={isFallbackEditing}
                    />
                </div>
            </div>
        </div>
    );
};
